import React from "react";
import { NavLink, Route, Switch } from "react-router-dom";
import { Panel } from "@culturehq/components";

import { useProfile } from "app/context";
import { Trans } from "app/utils";

import Feedback from "./Feedback";
import Flags from "./Flags";

const Review = () => {
  const { profile } = useProfile();
  const { organization: { feedbackEnabled } } = profile;

  return (
    <Panel limitWidth>
      <ul className="nav nav-tabs">
        {feedbackEnabled && (
          <li>
            <NavLink exact to="/admin/feedback" activeClassName="active">
              <Trans>Feedback</Trans>
            </NavLink>
          </li>
        )}
        <li>
          <NavLink to="/admin/flags" activeClassName="active">
            <Trans>Flags</Trans>
          </NavLink>
        </li>
      </ul>
      <Panel.Body>
        <Switch>
          {feedbackEnabled && <Route exact path="/admin/feedback" component={Feedback} />}
          <Route exact path="/admin/flags/:page?" component={Flags} />
        </Switch>
      </Panel.Body>
    </Panel>
  );
};

export default Review;
